import axios from "axios";
import { refreshToken } from "../api/AuthApi";
import { encryptPayload } from "../utils/encryptionRequest";

const api = axios.create({
  // baseURL: "https://localhost:44342/api", //https
  baseURL: "https://sapi.pharo.in/pixelus/api",
  //baseURL: "https://dev1.cirrius.in/pixelusapi/api",
   //baseURL: "https://cp3apiqc.cirrius.in/pixelusapi/api",
  //baseURL: "https://localhost:44317/api",
  // baseURL: "https://reactapp.cirrius.in/CirriusAccountAPI/api", //UAT
  // baseURL: "https://reactapi.cirrius.in/CirriusAccountAPI/api", //Live
  // baseURL: "https://dev1.cirrius.in/CirriusAPIGateway/api",
  //baseURL:process.env.REACT_APP_ACCOUNT_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    const skipEncryption = [
      "/account/SSOSignIn",
      "/account/GetTokenData",
      "/account/RefreshToken",
      "/account/GoogleRefresh",
      "/CommonMethods/UploadBlob",
      "/CommonMethods/UploadSasWise",
      "/DAM/saveSubmitData",
      "/DAM/SaveDraftAssets",
      "/DAM/CampCreationSave",
      "/DAM/SubRequestdetails",
      "/DAM/SubVendorReqdtl"
    ];

    const shouldSkip = skipEncryption.some(
      (x) => config.url?.toLowerCase() === x.toLowerCase()
    );

    if (!shouldSkip && config.data) {
      try {
        let body =
          typeof config.data === "string"
            ? JSON.parse(config.data)
            : config.data;

        if (body?.jsonstring) {
          body.jsonstring = await encryptPayload(body.jsonstring);
          config.data = JSON.stringify(body);
        }
      } catch (e) {
        console.log("Encryption Error", e);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// api.interceptors.request.use(
//   async (config) => {
//     const token = sessionStorage.getItem("token");
//     //Expired Token for testing expired time
//     // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VybmFtZSI6IlRlc3QxMDEiLCJDTElFTlRJRCI6IkNQMyIsIlBXRCI6IlQwMDAxIiwibmJmIjoxNjg3MzMyNzgxLCJleHAiOjE1ODczMzYzODksImlhdCI6MTY4NzMzMjc4MX0.aO-rpJZtTf4goSeGwevPodXwC_jMF2rFmrsnqqOBOVg"
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error instanceof Error ? error : new Error(error));
//   }
// );

api.interceptors.response.use(
  (response) => {
    // setSessionData(response.data);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      // let decryptedData = JSON.parse(AES.decrypt(refreshToken).toString(enc.Utf8));
      // console.log('decryptedData',decryptedData)
      const isSSOUser = sessionStorage.getItem("isSSOUser") === "1";
      if (!isSSOUser) {
        const accessToken = await refreshToken();

        if (accessToken) {
          api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
          return api(originalRequest);
        }
      }
    }
    return Promise.reject(error instanceof Error ? error : new Error(error));
  }
);

export default api;
